import React from 'react'

import { cn } from '@/lib/utils'

type Props = React.ComponentProps<'div'> & {
  children: React.ReactNode
}

const LayoutWrapper: React.FC<Props> = ({ children, className, ...props }) => (
  <div
    className={cn('flex w-full min-w-75 items-stretch', className)}
    {...props}
  >
    {children}
  </div>
)

export default LayoutWrapper
